import { UseMutationResult } from '@tanstack/react-query';

import { ApiError } from '../../../../Shared/interfaces/ApiError';
import { ApiResponseKeys } from '../../../../Shared/interfaces/ApiResponse';
import { QueueSheetManagementRows } from '../interface/QueueSheetInterface';

export const restoreBookingUtils = (
    setIsRestoreModalOpen: React.Dispatch<React.SetStateAction<boolean>>,
    setBookingToRestore: React.Dispatch<
        React.SetStateAction<QueueSheetManagementRows | null>
    >,
    bookingToRestore: QueueSheetManagementRows | null,
    restoreBookingMutation: UseMutationResult<
        ApiResponseKeys,
        ApiError,
        string,
        unknown
    >
) => {
    const handleRestoreClick = (booking: QueueSheetManagementRows) => {
        setBookingToRestore(booking);
        setIsRestoreModalOpen(true);
    };

    const handleRestoreCancel = () => {
        setIsRestoreModalOpen(false);
        setBookingToRestore(null);
        restoreBookingMutation.reset();
    };

    const handleRestoreConfirm = () => {
        if (bookingToRestore) {
            restoreBookingMutation.mutate(bookingToRestore.bookingId);
        }
    };

    return {
        handleRestoreClick,
        handleRestoreCancel,
        handleRestoreConfirm,
    };
};
